import { ACTIONS } from '../actions/actionTypes';
const debug = process.env.REACT_APP_DEBUG && false;
const initialState = {
    isAuthenticated: false,
    cognitoUser: undefined,
    didInvalidate: undefined,
};
const AccessReducer = (state = initialState, action) => {
    debug && action.type !== ACTIONS.CLEAR_MESSAGE_PING && console.log('Access Reducer action', action);
    switch (action.type) {
        case ACTIONS.REQUEST_AUTHENTICATE:
            return Object.assign({}, state, {
                didInvalidate: false,
            });
        case ACTIONS.RECEIVE_AUTHENTICATE:
            return Object.assign({}, state, {
                didInvalidate: false,
                cognitoUser: action.cognitoUser,
                isAuthenticated: true,
            });
        case ACTIONS.RECEIVE_AUTH_DENIED: {
            debug && console.log('AccessReducer auth denied', action);
            return Object.assign({}, state, {
                didInvalidate: true,
                isAuthenticated: action.code === 'NotAuthorizedException',
            });
        }
        case ACTIONS.NEW_PASSWORD_REQUIRED: {
            debug && console.log('AccessReducer NEW_PASSWORD_REQUIRED', action);
            const thisAction = action;
            return Object.assign({}, state, {
                didInvalidate: true,
                cognitoUser: thisAction.cognitoUser,
                isAuthenticated: false,
            });
        }
        case ACTIONS.RECEIVE_LOGOUT: {
            return Object.assign({}, state, {
                didInvalidate: false,
                isAuthenticated: false,
            });
        }
        case ACTIONS.REQUEST_REFRESH_WITH_USER_TOKEN: {
            debug && console.log('AccessReducer refresh', action);
            return { ...state };
        }
        case ACTIONS.RECIEIVE_REFRESH_WITH_USER_TOKEN: {
            debug && console.log('AccessReducer refresh', action);
            return Object.assign({}, state, {
                didInvalidate: false,
                cognitoUser: action.cognitoUser,
                isAuthenticated: true,
            });
        }
        default: {
            return state;
        }
    }
};
export default AccessReducer;
